const TermsConditions = () => {
  return (
    <div className="overflow-hidden">
      <section className="relative py-24 hero-gradient mesh-gradient">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold font-['Outfit'] tracking-tighter mb-6">
              Terms & Conditions
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Terms governing use of the Jnanit website, services, software, and integration solutions.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p><strong>Effective Date:</strong> 4/19/2026</p>
            <p><strong>Last Updated:</strong> 6/28/2026</p>

            <h2>1. Introduction</h2>
            <p>
              Welcome to Jnan Innovative IT Solutions ("Jnanit", "we", "our", or "us"). These Terms and Conditions govern your use of our website and services, including AI solutions, software development, system integrations, and Amazon Selling Partner API (SP-API) integrations.
            </p>
            <p>
              By accessing our website or using our services, you agree to these Terms. If you do not agree, please do not use our services.
            </p>
            <br />

            <h2>2. Services</h2>
            <p>
              Jnanit provides technology services including AI-powered solutions, software development, consulting, automation, cloud services, cybersecurity support, and integrations with platforms such as Amazon SP-API, ERP systems, and eCommerce platforms.
            </p>
            <p>
              All services are subject to project scope, written agreements, platform approvals, technical feasibility, and availability.
            </p>
            <br />

            <h2>3. User Responsibilities</h2>
            <ul>
              <li>You agree to provide accurate and complete information.</li>
              <li>You are responsible for maintaining the confidentiality of your own account credentials.</li>
              <li>You agree not to misuse our services, bypass security controls, or violate applicable laws or platform policies.</li>
              <li>You must authorize only the platform access required for the agreed service.</li>
            </ul>
            <br />

            <h2>4. Amazon SP-API and Restricted Data</h2>
            <p>
              Where our services integrate with Amazon SP-API, you agree that Amazon data will be used only for authorized seller operations and approved purposes. Amazon customer PII, when approved and required, may be used only for purposes such as merchant-fulfilled shipping, tax invoicing, tax remittance, or legal/regulatory obligations.
            </p>
            <p>
              Amazon customer PII must not be used for marketing, retargeting, customer profiling, resale, review manipulation, unrelated analytics, or cross-seller aggregation. We may refuse or discontinue work that requires prohibited use of Amazon data.
            </p>
            <br />

            <h2>5. Third-Party Services</h2>
            <p>
              Our services may integrate with third-party platforms. We are not responsible for the availability, performance, terms, or policies of third-party services. Your use of those platforms remains subject to their own agreements and policies.
            </p>
            <br />

            <h2>6. Fees and Payment</h2>
            <p>
              Pricing may be fixed, subscription-based, usage-based, or quote-based depending on the scope of work. Fees, payment milestones, and invoicing terms will be communicated before engagement or set out in a written agreement.
            </p>
            <br />

            <h2>7. Intellectual Property</h2>
            <p>
              Website content, templates, designs, software components, methods, and materials provided by Jnanit remain our intellectual property unless otherwise agreed in writing. Clients retain ownership of their data and deliverables explicitly assigned under a written agreement.
            </p>
            <br />

            <h2>8. Data Protection</h2>
            <p>
              We handle data according to our Privacy Policy, Amazon Data Protection Policy, Information Security Policy, and applicable data protection laws. Customers must not provide data that is unnecessary for the agreed services.
            </p>
            <br />

            <h2>9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Jnanit is not liable for indirect, incidental, consequential, special, or punitive damages arising from use of our website or services. We do not guarantee uninterrupted or error-free operation of services.
            </p>
            <br />

            <h2>10. Suspension or Termination</h2>
            <p>
              We may suspend or terminate services if these Terms are violated, payment obligations are not met, platform policies are breached, prohibited data use is requested, or misuse/security risk is detected.
            </p>
            <br />

            <h2>11. Changes to Terms</h2>
            <p>
              We may update these Terms periodically. Continued use of our website or services after updates constitutes acceptance of the revised Terms.
            </p>
            <br />

            <h2>12. Governing Law</h2>
            <p>
              These Terms are governed by applicable laws of the jurisdiction in which Jnanit operates, unless a written agreement specifies otherwise.
            </p>
            <br />

            <h2>13. Contact Us</h2>
            <p>
              Jnan Innovative IT Solutions<br />
              Email: info@jnanit.com<br />
              Website: https://jnanit.com
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
